import React, { Fragment, useState } from "react";
import { Descriptions, Row, Col, Radio, RadioChangeEvent } from "antd";
import styles from "../topology.module.scss";
import ReactECharts from "echarts-for-react";
// import "echarts/lib/chart/bar";
// import ReactEchartsCore from "echarts-for-react/lib/core";
// import echarts from "echarts/lib/echarts";
// import "echarts/lib/component/tooltip";
// import "echarts/lib/component/title";
// import "echarts/lib/component/legend";
import { Uptime } from "../../../Utility/Fetch";
import { StatusObj, identity } from "Utility/Types/status_identity_get_set";
import { useAppSelector } from "store/hook";

const BooleanCapitalizer = (data: boolean) => {
  switch (data) {
    case true:
      return "True";
    case false:
      return "False";
    default:
      return "";
  }
};

const BooleanToEnable = (data: boolean) => {
  switch (data) {
    case true:
      return "Enable";
    case false:
      return "Disable";
    default:
      return "";
  }
};

export const IdentityTableF = React.memo(
  ({
    deviceStatusByID,
    deviceIdentityByID,
  }: {
    deviceStatusByID: StatusObj | undefined;
    deviceIdentityByID: identity;
  }) => {
    const activeVersion = deviceIdentityByID?.partition.filter((item: any) => item.active);
    const firmwareVersion = activeVersion?.[0]?.software_mcsv.slice(8, 11);
    const ConnectionTine = deviceStatusByID?.status?.system?.uptime;

    return (
      deviceIdentityByID && (
        <div className="mt-1">
          <Descriptions bordered column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }} className={styles.desc}>
            <Descriptions.Item label="Active Image Partition">{activeVersion[0].name}</Descriptions.Item>

            {deviceIdentityByID.hardware_mcsv.slice(0, 4) !== "012E" && typeof deviceIdentityByID.IMEI !== "string" ? ( //M350 IMEI is Array
              <Fragment>
                <Descriptions.Item label="IMEI #1">{deviceIdentityByID.IMEI[0]}</Descriptions.Item>
                <Descriptions.Item label="IMEI #2">{deviceIdentityByID.IMEI[1]}</Descriptions.Item>
              </Fragment>
            ) : (
              <Descriptions.Item label="IMEI">{deviceIdentityByID.IMEI}</Descriptions.Item>
            )}

            <Descriptions.Item label="Bootloader Version">{deviceIdentityByID.bootloader_version}</Descriptions.Item>
            <Descriptions.Item label="Software MCSV">{activeVersion[0].software_mcsv}</Descriptions.Item>
            <Descriptions.Item label="Hardware MCSV">{deviceIdentityByID.hardware_mcsv}</Descriptions.Item>
            <Descriptions.Item label="Dual Image A MCSV">
              {deviceIdentityByID.partition?.[0]?.software_mcsv}
            </Descriptions.Item>
            <Descriptions.Item label="Dual Image B MCSV">
              {deviceIdentityByID.partition?.[1]?.software_mcsv}
            </Descriptions.Item>
            <Descriptions.Item label="Hostname">{deviceIdentityByID.hostname}</Descriptions.Item>
            <Descriptions.Item label="Model Name">
              {deviceIdentityByID.model_name || "Cellular Router"}
            </Descriptions.Item>
            <Descriptions.Item label="LAN Ethernet MAC">{deviceIdentityByID.lan_eth_mac}</Descriptions.Item>
            <Descriptions.Item label="Software Version">{deviceIdentityByID?.software_version}</Descriptions.Item>
            {deviceIdentityByID.hardware_mcsv.slice(0, 4) !== "012E" &&
            typeof deviceIdentityByID.modem_firmware_version !== "string" ? ( //M350 IMEI is Array
              <Fragment>
                <Descriptions.Item label="Modem Firmware Version #1">
                  {deviceIdentityByID.modem_firmware_version[0]}
                </Descriptions.Item>
                <Descriptions.Item label="Modem Firmware Version #2">
                  {deviceIdentityByID.modem_firmware_version[1]}
                </Descriptions.Item>
              </Fragment>
            ) : (
              <Descriptions.Item label="Modem Firmware Version">
                {deviceIdentityByID.modem_firmware_version}
              </Descriptions.Item>
            )}

            <Descriptions.Item label="Firmware Version">
              V{(Number(firmwareVersion) / 100).toFixed(2)}
            </Descriptions.Item>
            <Descriptions.Item label="Serial Number">{deviceIdentityByID.serial_number}</Descriptions.Item>
            <Descriptions.Item label="WAN Ethernet MAC">{deviceIdentityByID.wan_eth_mac}</Descriptions.Item>
            <Descriptions.Item label="WiFi AP MAC">
              {deviceIdentityByID?.["wifi_2.4G_mac"] || deviceIdentityByID?.wifi_ap_mac}
            </Descriptions.Item>
            {deviceIdentityByID?.wifi_5G_mac && (
              <Descriptions.Item label="WiFi 5G MAC">{deviceIdentityByID.wifi_5G_mac}</Descriptions.Item>
            )}
            {ConnectionTine && <Descriptions.Item label="Uptime">{Uptime(ConnectionTine)}</Descriptions.Item>}
          </Descriptions>
        </div>
      )
    );
  }
);

const numberToBoolean = (arg: number) => {
  if (arg === 1 || arg === 0) {
    return true;
  } else {
    return false;
  }
};

export const StateSIM = React.memo(({ deviceStatusByID }: { deviceStatusByID: StatusObj }) => {
  const sim1 = deviceStatusByID?.status?.sim?.[0];
  const sim2 = deviceStatusByID?.status?.sim?.[1];
  const [currentTag, setCurrentTag] = useState<"SIM1" | "SIM2">("SIM1");
  const simData = currentTag === "SIM1" ? sim1 : sim2;

  const onChange = (e: RadioChangeEvent) => {
    setCurrentTag(e.target.value);
  };

  return (
    <div className="mt-1">
      {sim2 && (
        <Radio.Group onChange={onChange} style={{ marginBottom: 16, padding: 0 }} defaultValue={"SIM1"}>
          <Radio.Button value={"SIM1"}>SIM1</Radio.Button>
          <Radio.Button value={"SIM2"}>SIM2</Radio.Button>
        </Radio.Group>
      )}
      <Descriptions column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }} bordered className={styles.desc}>
        <Descriptions.Item label="EARFCN">{simData.EARFCN}</Descriptions.Item>
        <Descriptions.Item label="IMSI">{simData.IMSI}</Descriptions.Item>
        {simData?.IMEI && <Descriptions.Item label="IMEI">{simData.IMEI}</Descriptions.Item>}
        <Descriptions.Item label="ICCID">{simData.ICCID}</Descriptions.Item>
        <Descriptions.Item label="PLMN">{simData.PLMN}</Descriptions.Item>
        <Descriptions.Item label="Access">{simData.access}</Descriptions.Item>
        <Descriptions.Item label="Active">{`${BooleanCapitalizer(simData.active)}`}</Descriptions.Item>
        <Descriptions.Item label="Band">{simData.band}</Descriptions.Item>
        <Descriptions.Item label="Operator">{simData.operator}</Descriptions.Item>

        <Descriptions.Item label="Phone Number">{simData.phone_number}</Descriptions.Item>
        <Descriptions.Item label="Roaming">{BooleanToEnable(simData.roaming)}</Descriptions.Item>
        {numberToBoolean(simData.signal) && <Descriptions.Item label="Signal">{simData.signal}</Descriptions.Item>}
        <Descriptions.Item label="RSSI (dBm)">{simData.rssi_dbm}</Descriptions.Item>
        {numberToBoolean(simData.rsrp_dbm) && (
          <Descriptions.Item label="RSRP (dBm)">{simData.rsrp_dbm}</Descriptions.Item>
        )}
        <Descriptions.Item label="Status">{simData.status}</Descriptions.Item>
      </Descriptions>
    </div>
  );
});

export const StateGPSF = React.memo(({ deviceStatusByID }: { deviceStatusByID: StatusObj }) => {
  const gps = deviceStatusByID.status?.gps;

  return (
    <div className="mt-1">
      <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
        <Descriptions.Item label="Altitude">{gps.altitude}</Descriptions.Item>
        <Descriptions.Item label="Date">{gps.date}</Descriptions.Item>
        <Descriptions.Item label="Horizontal">{gps.horizontal}</Descriptions.Item>
        <Descriptions.Item label="Latitude">{gps.latitude}</Descriptions.Item>
        <Descriptions.Item label="Longitude">{gps.longitude}</Descriptions.Item>
        <Descriptions.Item label="Satellite">{gps.satellite}</Descriptions.Item>
        <Descriptions.Item label="UTC-time">{gps["utc-time"]}</Descriptions.Item>
      </Descriptions>
    </div>
  );
});

export const StatesDNSF = React.memo(({ deviceStatusByID }: { deviceStatusByID: StatusObj }) => {
  const dns = deviceStatusByID.status?.dns;
  const dnsKeys: string[] = Object.keys(dns).map((item) => item.toUpperCase());
  const [currentTag, setCurrentTag] = useState(dnsKeys[0]);

  const onChange = (e: RadioChangeEvent) => {
    setCurrentTag(e.target.value);
  };

  return (
    <div className="mt-1">
      {dnsKeys?.length > 1 && (
        <Radio.Group onChange={onChange} style={{ marginBottom: 16 }} defaultValue={currentTag}>
          {dnsKeys.map((item, index) => (
            <Radio.Button key={index} value={item}>
              {item}
            </Radio.Button>
          ))}
        </Radio.Group>
      )}

      {currentTag === "WAN" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="IPv4 #1">{dns.wan[0].ipv4[0]}</Descriptions.Item>
          <Descriptions.Item label="IPv4 #2">{dns.wan[0].ipv4[1]}</Descriptions.Item>
          <Descriptions.Item label="IPv4 #3">{dns.wan[0].ipv4[2]}</Descriptions.Item>
          <Descriptions.Item label="IPv6 #1">{dns.wan[0].ipv6[0]}</Descriptions.Item>
          <Descriptions.Item label="IPv6 #2">{dns.wan[0].ipv6[1]}</Descriptions.Item>
          <Descriptions.Item label="IPv6 #3">{dns.wan[0].ipv6[2]}</Descriptions.Item>
        </Descriptions>
      )}

      {currentTag === "LAN" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="IPv6 #1">{dns.lan[0].ipv6[0]}</Descriptions.Item>
          <Descriptions.Item label="IPv6 #2">{dns.lan[0].ipv6[1]}</Descriptions.Item>
          <Descriptions.Item label="IPv6 #3">{dns.lan[0].ipv6[2]}</Descriptions.Item>
        </Descriptions>
      )}

      {currentTag === "SIM1" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="APN1 IPv4 #1">{dns.sim1[0].ipv4[0]}</Descriptions.Item>
          <Descriptions.Item label="APN1 IPv4 #2">{dns.sim1[0].ipv4[1]}</Descriptions.Item>
          <Descriptions.Item label="APN1 IPv4 #3">{dns.sim1[0].ipv4[2]}</Descriptions.Item>
          <Descriptions.Item label="APN2 IPv4 #1">{dns.sim1[1].ipv4[0]}</Descriptions.Item>
          <Descriptions.Item label="APN2 IPv4 #2">{dns.sim1[1].ipv4[1]}</Descriptions.Item>
          <Descriptions.Item label="APN2 IPv4 #3">{dns.sim1[1].ipv4[2]}</Descriptions.Item>
        </Descriptions>
      )}

      {currentTag === "SIM2" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="APN1 IPv4 #1">{dns.sim2[0].ipv4[0]}</Descriptions.Item>
          <Descriptions.Item label="APN1 IPv4 #2">{dns.sim2[0].ipv4[1]}</Descriptions.Item>
          <Descriptions.Item label="APN1 IPv4 #3">{dns.sim2[0].ipv4[2]}</Descriptions.Item>
          <Descriptions.Item label="APN2 IPv4 #1">{dns.sim2[1].ipv4[0]}</Descriptions.Item>
          <Descriptions.Item label="APN2 IPv4 #2">{dns.sim2[1].ipv4[1]}</Descriptions.Item>
          <Descriptions.Item label="APN2 IPv4 #3">{dns.sim2[1].ipv4[2]}</Descriptions.Item>
        </Descriptions>
      )}
    </div>
  );
});

export const StateConnectionF = React.memo(({ deviceStatusByID }: { deviceStatusByID: StatusObj }) => {
  const connection = deviceStatusByID.status?.connection;
  const connectionKeys: string[] = Object.keys(connection).map((item) => item.toUpperCase());
  const [currentTag, setCurrentTag] = useState(connectionKeys[0]);

  const onChange = (e: RadioChangeEvent) => {
    setCurrentTag(e.target.value);
  };
  return (
    <div className="mt-1">
      {connectionKeys && (
        <Radio.Group onChange={onChange} style={{ marginBottom: 16 }} defaultValue={currentTag}>
          {connectionKeys.map((item, index) => (
            <Radio.Button key={index} value={item}>
              {item}
            </Radio.Button>
          ))}
        </Radio.Group>
      )}

      {currentTag === "LAN" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="IPv4 Address">{connection.lan.ipv4.address}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Mask">{connection.lan.ipv4.netmask}</Descriptions.Item>
          <Descriptions.Item label="IPv6 Address">{connection.lan.ipv6.address}</Descriptions.Item>
          <Descriptions.Item label="IPv6 Uptime">{Uptime(connection.lan.ipv6.uptime)}</Descriptions.Item>
        </Descriptions>
      )}

      {currentTag === "LTE" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="Active">{BooleanCapitalizer(connection.lte.active)}</Descriptions.Item>
          <Descriptions.Item label="IPv4(APN1) Address">{connection.lte.apn[0].ipv4.address}</Descriptions.Item>
          <Descriptions.Item label="IPv4(APN1) Gateway">{connection.lte.apn[0].ipv4.gateway}</Descriptions.Item>
          <Descriptions.Item label="IPv4(APN1) Mask">{connection.lte.apn[0].ipv4.netmask}</Descriptions.Item>
          <Descriptions.Item label="IPv4(APN1) Uptime">{Uptime(connection.lte.apn[0].ipv4.uptime)}</Descriptions.Item>

          {connection?.lte?.apn?.[1]?.ipv4 && (
            <Fragment>
              <Descriptions.Item label="IPv4(APN2) Address">{connection.lte.apn[1].ipv4.address}</Descriptions.Item>
              <Descriptions.Item label="IPv4(APN2) Gateway">{connection.lte.apn[1].ipv4.gateway}</Descriptions.Item>
              <Descriptions.Item label="IPv4(APN2) Mask">{connection.lte.apn[1].ipv4.netmask}</Descriptions.Item>
              <Descriptions.Item label="IPv4(APN2) Uptime">
                {Uptime(connection.lte.apn[1].ipv4.uptime)}
              </Descriptions.Item>
            </Fragment>
          )}
        </Descriptions>
      )}
      {currentTag === "WAN" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="Active">{BooleanCapitalizer(connection.wan.active)}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Address">{connection.wan.ipv4.address}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Gateway">{connection.wan.ipv4.gateway}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Mask">{connection.wan.ipv4.netmask}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Uptime">{Uptime(connection.wan.ipv4.uptime)}</Descriptions.Item>
        </Descriptions>
      )}
      {currentTag === "WWAN" && (
        <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
          <Descriptions.Item label="Active">{BooleanCapitalizer(connection.wwan.active)}</Descriptions.Item>
          <Descriptions.Item label="IPv4 MAC">{connection.wwan.ipv4.MAC}</Descriptions.Item>
          <Descriptions.Item label="IPv4 SSID">{connection.wwan.ipv4.SSID}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Address">{connection.wwan.ipv4.address}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Channel">{connection.wwan.ipv4.channel}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Gateway">{connection.wwan.ipv4.gateway}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Mask">{connection.wwan.ipv4.netmask}</Descriptions.Item>
          <Descriptions.Item label="IPv4 Uptime">{Uptime(connection.wwan.ipv4.uptime)}</Descriptions.Item>
        </Descriptions>
      )}

      {currentTag === "SIM1" && (
        <Fragment>
          <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
            <Descriptions.Item label="APN1 Active">{BooleanCapitalizer(connection.sim1[0].active)}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Address">{connection.sim1[0].ipv4.address}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Mask">{connection.sim1[0].ipv4.netmask}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Gateway">{connection.sim1[0].ipv4.gateway}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Uptime">{Uptime(connection.sim1[0].ipv4.uptime)}</Descriptions.Item>
          </Descriptions>
          <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
            <Descriptions.Item label="APN2 Active">{BooleanCapitalizer(connection.sim1[1].active)}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Address">{connection.sim1[1].ipv4.address}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Mask">{connection.sim1[1].ipv4.netmask}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Gateway">{connection.sim1[1].ipv4.gateway}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Uptime">{Uptime(connection.sim1[1].ipv4.uptime)}</Descriptions.Item>
          </Descriptions>
        </Fragment>
      )}

      {currentTag === "SIM2" && (
        <Fragment>
          <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
            <Descriptions.Item label="APN1 Active">{BooleanCapitalizer(connection.sim2[0].active)}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Address">{connection.sim2[0].ipv4.address}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Mask">{connection.sim2[0].ipv4.netmask}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Gateway">{connection.sim2[0].ipv4.gateway}</Descriptions.Item>
            <Descriptions.Item label="APN1 IPv4 Uptime">{Uptime(connection.sim2[0].ipv4.uptime)}</Descriptions.Item>
          </Descriptions>
          <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
            <Descriptions.Item label="APN2 Active">{BooleanCapitalizer(connection.sim2[1].active)}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Address">{connection.sim2[1].ipv4.address}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Mask">{connection.sim2[1].ipv4.netmask}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Gateway">{connection.sim2[1].ipv4.gateway}</Descriptions.Item>
            <Descriptions.Item label="APN2 IPv4 Uptime">{Uptime(connection.sim2[1].ipv4.uptime)}</Descriptions.Item>
          </Descriptions>
        </Fragment>
      )}
    </div>
  );
});

export const StateTxRxF = React.memo(
  ({
    deviceStatusByID,
    isDarkMode,
    deviceIdentityByID,
    modelHideLTE,
  }: {
    deviceStatusByID: StatusObj;
    isDarkMode: boolean;
    deviceIdentityByID?: identity;
    modelHideLTE?: boolean;
  }) => {
    const [currentValue, setCurrentValue] = useState("Tx/Rx");
    const statistic = deviceStatusByID?.status?.statistic;

    const getOption = () => {
      const option = {
        title: {
          show: true,
          text: "",
          right: "auto",
          left: "auto",
        },
        legend: { show: true, right: "10%" },
        tooltip: {},
        xAxis: { type: "category" as "category" },
        yAxis: { name: "kbytes" },
        dataset: {},
        series: [{}],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
      };

      if (currentValue === "Tx/Rx") {
        const dataset = {
          source: [
            ["product", "tx", "rx"],
            ["WAN", statistic?.wan.tx_kbytes, statistic?.wan.rx_kbytes],
            ["LAN", statistic?.lan.tx_kbytes, statistic?.lan.rx_kbytes],
          ],
        };
        if (deviceIdentityByID?.hardware_mcsv.slice(0, 4) !== "012E" && !modelHideLTE) {
          if (statistic?.lte) {
            dataset.source.push(
              // ["LTE", statistic?.lte.tx_kbytes, statistic?.lte.rx_kbytes],
              ["LTE(APN)", statistic?.lte.apn[0].tx_kbytes, statistic?.lte.apn[0].rx_kbytes]
            );
          } else {
            //M350
            dataset.source.push(
              ["SIM1_APN1", statistic?.sim1[0].tx_kbytes, statistic?.sim1[0].rx_kbytes],
              ["SIM1_APN2", statistic?.sim1[1].tx_kbytes, statistic?.sim1[1].rx_kbytes],
              ["SIM2_APN1", statistic?.sim2[0].tx_kbytes, statistic?.sim2[0].rx_kbytes],
              ["SIM2_APN2", statistic?.sim2[1].tx_kbytes, statistic?.sim2[1].rx_kbytes]
            );
          }
        }

        option.dataset = dataset;

        option.series = [{ type: "bar" }, { type: "bar" }];
      } else if (currentValue === "Tx/Rx Dropped") {
        const dataset = {
          source: [
            ["product", "tx", "rx"],
            ["WAN", statistic?.lan.tx_dropped_pkts, statistic?.lan.rx_dropped_pkts],
            ["LAN", statistic?.lan.tx_dropped_pkts, statistic?.lan.rx_dropped_pkts],
          ],
        };

        if (deviceIdentityByID?.hardware_mcsv.slice(0, 4) !== "012E" && !modelHideLTE) {
          if (statistic?.lte) {
            dataset.source.push(
              // ["LTE", statistic?.lte.tx_dropped_pkts, statistic?.lte.rx_dropped_pkts],
              ["LTE(APN)", statistic?.lan.tx_dropped_pkts, statistic?.lan.rx_dropped_pkts]
            );
          } else {
            //M350
            dataset.source.push(
              ["SIM1_APN1", statistic?.sim1[0].tx_dropped_pkts, statistic?.sim1[0].rx_dropped_pkts],
              ["SIM1_APN2", statistic?.sim1[1].tx_dropped_pkts, statistic?.sim1[1].rx_dropped_pkts],
              ["SIM2_APN1", statistic?.sim2[0].tx_dropped_pkts, statistic?.sim2[0].rx_dropped_pkts],
              ["SIM2_APN2", statistic?.sim2[1].tx_dropped_pkts, statistic?.sim2[1].rx_dropped_pkts]
            );
          }
        }

        option.dataset = dataset;
        option.series = [{ type: "bar" }, { type: "bar" }];
      } else {
        const axis =
          (deviceIdentityByID?.hardware_mcsv.slice(0, 4) === "012E" || modelHideLTE) && statistic?.lte === undefined
            ? ["WAN", "LAN"]
            : statistic?.lte
            ? ["WAN", "LAN", "LTE"]
            : ["WAN", "LAN", "SIM1_APN1", "SIM1_APN2", "SIM2_APN1", "SIM2_APN2"]; //M350
        //@ts-ignore
        option.xAxis.data = axis;

        let data;
        if (currentValue === "Uplink Speed") {
          data =
            (deviceIdentityByID?.hardware_mcsv.slice(0, 4) === "012E" || modelHideLTE) && statistic?.lte === undefined
              ? [statistic?.wan.up_kbps, statistic?.lan.up_kbps]
              : statistic?.lte
              ? [
                  statistic?.wan.up_kbps,
                  statistic?.lan.up_kbps,
                  //  statistic?.lte.up_kbps,
                  statistic?.lte.apn[0].up_kbps,
                ]
              : [
                  //M350
                  statistic?.wan.up_kbps,
                  statistic?.lan.up_kbps,
                  statistic?.sim1[0].up_kbps,
                  statistic?.sim1[1].up_kbps,
                  statistic?.sim2[0].up_kbps,
                  statistic?.sim2[1].up_kbps,
                ];
        } else {
          data =
            (deviceIdentityByID?.hardware_mcsv.slice(0, 4) === "012E" || modelHideLTE) && statistic?.lte === undefined
              ? [statistic?.wan.down_kbps, statistic?.lan.down_kbps]
              : statistic?.lte
              ? [
                  statistic?.wan.down_kbps,
                  statistic?.lan.down_kbps,
                  // statistic?.lte.down_kbps,
                  statistic?.lte.apn[0].down_kbps,
                ]
              : [
                  //M350
                  statistic?.wan.down_kbps,
                  statistic?.lan.down_kbps,
                  statistic?.sim1[0].down_kbps,
                  statistic?.sim1[1].down_kbps,
                  statistic?.sim2[0].down_kbps,
                  statistic?.sim2[1].down_kbps,
                ];
        }

        option.series = [
          {
            data: data,
            type: "bar",
          },
        ];
      }
      return option;
    };

    const onChange = (e: RadioChangeEvent) => {
      setCurrentValue(e.target.value);
    };

    return (
      <div className="mt-1">
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Radio.Group onChange={onChange} value={currentValue} defaultValue={"Tx/Rx"}>
              <Radio.Button value={"Tx/Rx"}>Tx/Rx</Radio.Button>
              <Radio.Button value={"Tx/Rx Dropped"}>Tx/Rx Dropped</Radio.Button>
              <Radio.Button value={"Uplink Speed"}>Uplink Speed</Radio.Button>
              <Radio.Button value={"Downlink Speed"}>Downlink Speed</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <ReactECharts
              // echarts={echarts}
              option={getOption()}
              notMerge={true}
              lazyUpdate={true}
              theme={isDarkMode ? "dark" : "default"}
              className={styles.echartBar}
            />
          </Col>
        </Row>
      </div>
    );
  }
);
